import React from "react";
import styled from "styled-components";
import SelectWithSearch from "../../../components/selectWithSearch";

const Container = styled.div`
    width: 300px;
    margin: 0 10px;
`;

const optionsForOrganizationAssignees = [
    { label: "Managerial", value: "Managerial" },
    { label: "On-ground Operations", value: "On-ground Operations" },
];

function OrganizationAssigneesOptionsFilter({
    organizationAssigneesOptions,
    setOrganizationAssigneesOptions,
}) {
    const onOrganizationAssigneesTypeChange = (event) => {
        setOrganizationAssigneesOptions(event);
    };

    return (
        <Container>
            <SelectWithSearch
                isEditable
                isMulti
                options={optionsForOrganizationAssignees}
                handleChange={onOrganizationAssigneesTypeChange}
                value={organizationAssigneesOptions}
                placeholder="Assignment Type"
            />
        </Container>
    );
}

export default OrganizationAssigneesOptionsFilter;
